/**
 * Um único formatador de moeda para o módulo. Antes disso cada seção montava o
 * seu `Intl.NumberFormat` (DaycarePlansSection, DailyRatesSection,
 * ReservationComanda), o que espalhava a escolha de locale e de moeda.
 *
 * Os valores chegam em reais, não centavos.
 *
 * O prefixo "R$ " é montado manualmente (em vez de `style: "currency"`)
 * porque o espaçamento que o ICU insere entre símbolo e número para BRL varia
 * por locale/versão (nenhum espaço em en-US, espaço não-quebrável em pt-BR),
 * o que tornaria o resultado inconsistente entre ambientes.
 */
export function formatStayCurrency(value: number | null | undefined, language: string): string {
  const locale = language.startsWith("pt") ? "pt-BR" : "en-US";
  const amount = new Intl.NumberFormat(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value ?? 0);
  return `R$ ${amount}`;
}
